/**
 * Theme based constants such as sizing and colors
 */

export const VERTICAL_WELL_GAP = 24

/**
 * A fixed label column with a value column that takes the rest, rather than a
 * fraction of the grid: the label width has to follow the label text, not the
 * width of the well. The value column wraps under its label once the well is
 * too narrow to hold both.
 */
export const SETTINGS_WELL_FORM_LAYOUT = {
    // Wide enough for the longest label in these wells ("Service Account JSON File URL") on one
    // line with a gap before the value. Wrapping a label made the row taller than its fixed height.
    labelCol: { flex: '0 0 220px' },
    wrapperCol: { flex: '1 1 240px', style: { minWidth: 0 } },
}
